module.exports = __webpack_public_path__ + "static/media/Mariscos.7d4b755c.svg";